import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface SecondaryButtonProps extends ButtonProps {
  boxShadow?: boolean;
}

const SecondaryButton = (props: SecondaryButtonProps): JSX.Element => {
  const { onClick, children, boxShadow, type, disabled } = props;

  return (
    <Button
      disableRipple
      variant="contained"
      onClick={onClick}
      color="secondary"
      type={type}
      disabled={disabled}
      endIcon={props.endIcon}
      sx={[
        {
          borderRadius: "4px",
          width: "100%",
          boxShadow: boxShadow ? "0px 4px 4px rgba(215, 192, 192, 0.5)" : "unset",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "secondary.light",
            opacity: 0.3,
          },
        },
      ]}>
      {children}
    </Button>
  );
};

export default SecondaryButton;
